module.exports = __webpack_public_path__ + "media/images/icon-changebydesign-e2755a817aa047e101bbbfb84367a5c4.svg";